import { createContext } from "react";

export interface AuthContext {
    isAuthenticated: boolean | null;
}

export const AuthContext = createContext<AuthContext>({
    isAuthenticated: null,
});
